import { isoZ, z } from 'my-zod'

const customerOrderCartVehiclesModel = z.object({
  id: z.string().uuid(),
  assetFamilyId: z.string(),

  pricingOverride: z.number().int().nonnegative().nullable(),
  quotedDate: isoZ.instant(),
  quotedDateLocal: isoZ.date(),
  quotedTimeLocal: isoZ.time(),
  numberOfUnitsAvailable: z.number().int().nonnegative()
})

const customerOrderCartModel = z.object({
  id: z.string().uuid(),

  productId: z.string().uuid(),
  productVersionId: z.number(),
  creatingCustomerSessionId: z.string(),
  customerOrderId: z.string().uuid().nullable(),
  reservedCustomerOrderShortId: z.string(),
  hypotheticalCustomerId: z.string().nullable(),

  beginDate: isoZ.date(),
  endDate: isoZ.date(),
  ridingStartTime: isoZ.time(),
  ridingEndTime: isoZ.time(),
  abandonedDate: isoZ.instant().nullable(),

  vehicles: customerOrderCartVehiclesModel.array().min(1),

  firstName: z.string(),
  lastName: z.string(),
  phone: z.string(),
  email: z.string(),
  bookingMethod: z.enum(['adv', 'advWhiteLabel', 'select', 'viator']),
  promotionDiscounts: z
    .object({
      promotion: z.object({
        id: z.string(),
        versionId: z.number(),
        code: z.string().nullable()
      }),
      discountId: z.string()
    })
    .array(),
  giftCardRedemptionCodes: z.string().array(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

const customerOrderCartVehiclesCreate = customerOrderCartVehiclesModel.augment({ signature: z.string().min(1) })

const customerOrderCartCreate = customerOrderCartModel
  .omit({
    createdDate: true,
    lastModifiedDate: true,
    customerOrderId: true,
    abandonedDate: true,
    creatingCustomerSessionId: true,
    deletedDate: true
  })
  .extend({ vehicles: customerOrderCartVehiclesCreate.array() })

const customerOrderCartsSystemView = customerOrderCartModel

export const CustomerOrderCartSchemas = {
  customerOrderCartVehiclesModel,
  customerOrderCartModel,
  customerOrderCartCreate,
  customerOrderCartVehiclesCreate,
  customerOrderCartsSystemView
}

export declare namespace CustomerOrderCartSchemas {
  type customerOrderCartVehiclesModel = z.infer<typeof customerOrderCartVehiclesModel>
  type customerOrderCartModel = z.infer<typeof customerOrderCartModel>
  type customerOrderCartVehiclesCreate = z.infer<typeof customerOrderCartVehiclesCreate>
  type customerOrderCartCreate = z.infer<typeof customerOrderCartCreate>
  type customerOrderCartsSystemView = z.infer<typeof customerOrderCartsSystemView>
}
